"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

export interface ClientRedirectProps {
  href: string;
  replace?: boolean;
}

/**
 * Navigate as a render result without calling router during render.
 * Next.js Router setState in the same turn as the caller's render/effects
 * throws "Cannot update a component (Router) while rendering...".
 */
export function ClientRedirect({ href, replace = true }: ClientRedirectProps) {
  const router = useRouter();
  useEffect(() => {
    const id = window.setTimeout(() => {
      if (replace) {
        router.replace(href);
      } else {
        router.push(href);
      }
    }, 0);
    return () => window.clearTimeout(id);
  }, [href, replace, router]);
  return null;
}
